import API from './axios'

export const sendMessageToPortalOwner = (
  { subject, message, publisher },
  portalAbbr,
) =>
  API.post(`${portalAbbr}/email/portal/send`, {
    subject,
    message,
    publisher,
  })

export const sendMessageToPublishers = (
  { message, receiptNumbers },
  portalAbbr,
) =>
  API.post(`/${portalAbbr}/publisher/question`, {
    message,
    receiptNumbers,
  })
